'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  display: block;\n  top: 0;\n  width: 100vw;\n  height: 0.4rem;\n  border: 0;\n  background-color: transparent;\n  color: rgb(97, 13, 255);\n  z-index: 1;\n\n  &::-webkit-progress-bar {\n    background: #FFF;\n  }\n\n  &::-webkit-progress-value {\n    background: rgb(97, 13, 255);\n  }\n\n  &::-moz-progress-bar {\n    background-color: rgb(97, 13, 255);\n  }\n\n  ', '\n'], ['\n  position: fixed;\n  display: block;\n  top: 0;\n  width: 100vw;\n  height: 0.4rem;\n  border: 0;\n  background-color: transparent;\n  color: rgb(97, 13, 255);\n  z-index: 1;\n\n  &::-webkit-progress-bar {\n    background: #FFF;\n  }\n\n  &::-webkit-progress-value {\n    background: rgb(97, 13, 255);\n  }\n\n  &::-moz-progress-bar {\n    background-color: rgb(97, 13, 255);\n  }\n\n  ', '\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _throttle = require('./throttle');
var _throttle2 = _interopRequireDefault(_throttle);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Progress = function Progress(_ref) {
  var value = _ref.value,
    max = _ref.max,
    className = _ref.className;
  return _react2.default.createElement('progress', {
    value: value,
    max: max,
    className: className
  });
};
var StyledProgress = (0, _styledComponents2.default)(Progress)(_templateObject, function (props) {
  return props.style;
});
var ReadingProgress = function (_React$Component) {
  (0, _inherits3.default)(ReadingProgress, _React$Component);
  (0, _createClass3.default)(ReadingProgress, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        targetEl: _propTypes2.default.string,
        className: _propTypes2.default.string,
        style: _propTypes2.default.object,
        hideNoAndFullProgress: _propTypes2.default.bool
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {};
    }
  }]);
  function ReadingProgress(props) {
    (0, _classCallCheck3.default)(this, ReadingProgress);
    var _this = (0, _possibleConstructorReturn3.default)(this, (ReadingProgress.__proto__ || (0, _getPrototypeOf2.default)(ReadingProgress)).call(this, props));
    _this.handleResize = function () {
      (0, _throttle2.default)(_this.measure(), 100);
    };
    _this.handleScroll = function () {
      (0, _throttle2.default)(_this.update(), 100);
    };
    _this.update = function () {
      var value = !_this.props.rootEl ? window.pageYOffset || document.documentElement.scrollTop : _this.rootEl.scrollTop;
      if (_this.props.targetEl) {
        if (_this.targetEl.getBoundingClientRect().top >= 0) {
          value = 0;
        } else {
          value = value - (_this.targetEl.getBoundingClientRect().top + window.pageYOffset);
        }
      }
      _this.hideProgress(value);
      _this.setState({
        value: value
      });
    };
    _this.hideProgress = function (value) {
      if (_this.props.hideNoAndFullProgress) {
        if (value <= 0 || value >= _this.max) {
          _this.props.style.display = 'none';
        } else {
          _this.props.style.display = '';
        }
      }
    };
    _this.targetEl = null;
    _this.rootEl = null;
    _this.max = 0;
    _this.viewportH = 0;
    _this.targetHeight = 0;
    _this.hideProgress(0);
    _this.state = {
      value: 0
    };
    return _this;
  }
  (0, _createClass3.default)(ReadingProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      this.targetEl = props.targetEl ? document.querySelector(props.targetEl) : document.body;
      this.rootEl = props.rootEl ? document.querySelector(props.rootEl) : window;
      this.measure();
      this.rootEl.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.rootEl.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'measureViewportHeight',
    value: function measureViewportHeight() {
      return !this.props.rootEl ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : this.rootEl.clientHeight;
    }
  }, {
    key: 'measure',
    value: function measure() {
      if (this.targetEl) {
        this.targetHeight = this.targetEl.getBoundingClientRect().height;
      }
      this.viewportH = this.measureViewportHeight();
      this.max = this.targetHeight - this.viewportH;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(StyledProgress, {
        value: this.state.value,
        max: this.max,
        className: this.props.className,
        style: this.props.style
      });
    }
  }]);
  return ReadingProgress;
}(_react2.default.Component);
exports.default = ReadingProgress;